import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from '../services/shared.service';
import { SellerFlow, SESSION_STORAGE_KEYS } from '../types/types';

@Injectable({
  providedIn: 'root',
})
export class PublishedSellerGuard implements CanActivate {

  constructor(private router: Router, private sharedService: SharedService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const sellerStatus = this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.SELLER_STATUS);
    const sellerId = this.sharedService.getDataFromSessionStorage(SESSION_STORAGE_KEYS.USER_ID)
    return sellerStatus === SellerFlow.APPROVED && sellerId ? true : sellerId ?  this.router.createUrlTree(['/register',sellerId]) :  this.router.createUrlTree(['/home']);
  }
}
